import {SET_TAB_INDEX} from "../constants/actionTypes";

export function setSlideTabIndex(index) {
    return {type: SET_TAB_INDEX, index};
}